import React, { useEffect, useState } from "react";
import VisitRosheta from "./VisitRosheta";
import { FaPenFancy, FaPills, FaStethoscope } from "react-icons/fa";
import MyLines from "./MyLines";
import { Col, Row } from "react-bootstrap";
import { TbListSearch } from "react-icons/tb";
import VisitCheckListRender from "./VisitCheckListRender";
import VisitCheckListForm from "./VisitCheckListForm";
import VisitPhysicianNote from "./VisitPhysicianNote";

const VisitPhysicianSection = ({ visit, clinic }) => {
  const [showEditCheckLists, setShowEditCheckLists] = useState(false);
  const [visitCheckLists, setVisitCheckLists] = useState(
    visit?.physicianSection?.visitCheckLists
      ? visit.physicianSection.visitCheckLists
      : [],
  );
  const [missedCheckLists, setMissedCheckLists] = useState([]);
  const [referesh, setReferesh] = useState(false);

  useEffect(() => {
    // find missed scan
    if (!visitCheckLists) {
      setMissedCheckLists(
        clinic?.clinicCheckLists.map((cc) => {
          return {
            titleId: cc._id,
            title: cc.title,
          };
        }),
      );
    } else if (visitCheckLists.length < clinic?.clinicCheckLists?.length) {
      setMissedCheckLists(
        clinic.clinicCheckLists.filter(
          (s) =>
            !visitCheckLists?.find(
              (ss) => ss.titleId.toString() === s._id.toString(),
            ),
        ),
      );
    } else {
      setMissedCheckLists([]);
    }
  }, [visitCheckLists, clinic, referesh]);
  return (
    <div className="my-3">
      <h4
        className="text-center text-white p-4"
        style={{ backgroundColor: "#14A44D" }}
      >
        {" "}
        <FaStethoscope /> Physician Section
      </h4>
      {/* ========================== CHECKLISTS ============================= */}
      <Row className="text-center">
        <h2 className="col">
          {" "}
          <TbListSearch /> Clinical Checklists
        </h2>
      </Row>
      {showEditCheckLists ? (
        <>
          <VisitCheckListForm
            visitCheckLists={visitCheckLists}
            setVisitCheckLists={setVisitCheckLists}
            missedCheckLists={missedCheckLists}
            referesh={referesh}
            setReferesh={setReferesh}
            visitId={visit._id}
            setShowEdit={setShowEditCheckLists}
            clinic={clinic}
          />
        </>
      ) : (
        <VisitCheckListRender
          setShowEdit={setShowEditCheckLists}
          visitCheckLists={visitCheckLists}
        />
      )}
      <MyLines type={`dashed`} />
      {/* ========================== Notes ============================= */}
      <Row className="text-center">
        <h2 className="col">
          {" "}
          <FaPenFancy /> Physician Notes
        </h2>
      </Row>
      <VisitPhysicianNote visit={visit} />
      <MyLines type={`dashed`} />
      {/* ========================== Rosheta ============================= */}
      <Row className="text-center">
        <h2 className="col">
          {" "}
          <FaPills /> Medications
        </h2>
      </Row>
      <VisitRosheta visit={visit} />
      {/* ========================== FOOTER ============================= */}
      <div
        className="text-center mt-3 p-3 rounded border small text-muted"
        style={{
          backgroundColor: "#D4F0DF",
          border: "1px solid #14A44D",
        }}
      >
        <div className="mb-2">
          <strong className="text-dark">
            {visit.physicianDetails?.firstName}{" "}
            {visit.physicianDetails?.lastName}
          </strong>{" "}
          <span>تم التسجيل بواسطة </span>
        </div>

        <Row className="justify-content-center gap-3 flex-wrap mb-3 g-0">
          <Col className="col-auto">
            <span className="fw-semibold">آخر تحديث: </span>
            {new Date(visit.physicianSection.updatedAt).toLocaleString("ar-EG")}
          </Col>
          <Col className="col-auto">
            <span className="fw-semibold">تاريخ الإنشاء: </span>
            {new Date(visit.physicianSection.createdAt).toLocaleString("ar-EG")}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default VisitPhysicianSection;
